import { useEffect, useState } from 'react';
import styles from './ProgressBar.module.css';

const ProgressBar = ({ current, target, height = 14 }) => {
  const [width, setWidth] = useState(0);
  const pct = Math.min(100, Math.round((current / target) * 100)) || 0;

  useEffect(() => {
    const timer = setTimeout(() => setWidth(pct), 80);
    return () => clearTimeout(timer);
  }, [pct]);

  return (
    <div className={styles.track} style={{ height }} role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
      <div className={styles.fill} style={{ width: `${width}%`, height }} />
    </div>
  );
};

export default ProgressBar;
